export enum TABS {
  APPLICATIONS_SOURCES = 'Applications sources',
  PRODUITS = 'Produits / Imputations comptables',
  MODES_REGLEMENT = 'Modes de règlement',
  QUALITE = 'Qualité',
}

export enum PREPROD_TABS {
  APPLICATIONS_SOURCES = 'Applications sources',
  PRODUITS = 'Produits / Imputations comptables',
  MODES_REGLEMENT = 'Modes de règlement',
}
